import { COUPON_ROUTE_NAME } from '@/libs/route-name';
import type { RouteRecordRaw } from 'vue-router';

export const couponRoute = (): RouteRecordRaw => {
  return {
    path: '/manage/coupon',
    name: COUPON_ROUTE_NAME.COUPON_LIST,
    component: () => import('@/pages/manage/coupon/list.vue'),
  }
};

export const couponAddRoute = (): RouteRecordRaw => {
  return {
    path: '/manage/coupon/add',
    name: COUPON_ROUTE_NAME.ADD_COUPON,
    component: () => import('@/pages/manage/coupon/add.vue'),
  }
};

export const couponEditRoute = (): RouteRecordRaw => {
  return {
    path: '/manage/coupon/edit/:id',
    name: COUPON_ROUTE_NAME.EDIT_COUPON,
    component: () => import('@/pages/manage/coupon/edit.vue'),
  }
};
